import { FloorCollapseSimulation } from "./simulation";

const canvas = document.querySelector<HTMLCanvasElement>("#scene");

if (canvas) {
  try {
    const simulation = new FloorCollapseSimulation(canvas);

    window.addEventListener("pagehide", (event) => {
      if (!event.persisted) simulation.dispose();
    });
  } catch (error) {
    console.error("[portfolio] Floor Collapse simulation could not start.", error);
  }
}
